import React from 'react';
// import Announcement from './Announcement';
import MailChimp from './MailChimp';
import FullWidthSection from './FullWidthSection'

export default props => {

  // [show, title, text, link] = props.announcement


  // const { show, title, text, link } = this.props.announcement
  const { acf, onScrolledOverDifferentColor } = props

  const showAnnouncement =
    acf.news_alert.news_show && acf.news_alert.news_show !== '0'
  
  // if(props.announcement.show){
    return (
      <div className="home-styles">
        {/* {showAnnouncement && <Announcement announcement={acf.news_alert} />} */}
        {acf.mailchimp && (
          <FullWidthSection
            onScrolledOverDifferentColor={onScrolledOverDifferentColor}
          >
            <MailChimp mailchimp={acf.mailchimp} />
          </FullWidthSection>
        )}
      </div>
    )
  // }

};
